import { render, staticRenderFns } from "./ReportEnrolmentProfile.vue?vue&type=template&id=263733b4&scoped=true&"
import script from "./ReportEnrolmentProfile.vue?vue&type=script&lang=js&"
export * from "./ReportEnrolmentProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "263733b4",
  null
  
)

export default component.exports